module.exports = __webpack_public_path__ + "static/img/win10_1.11985e1.png";